import React from 'react'

import Section from '@components/Section/Section'

import { NumberCountersType } from '@contracts/Components/NumberCounters'

import NumberCountersList from './NumberCountersList'
import * as styles from './NumberCountersSection.module.scss'

interface Props {
	data: NumberCountersType
}

const NumberCountersSection = (props: Props) => {
	return (
		<Section className={styles.section} type="wide">
			<NumberCountersList counters={props.data.counters} />
		</Section>
	)
}

export default NumberCountersSection
